import React, { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { ReactComponent as ChevronLeft } from "Assets/icons/chevronLeft.svg";
import Sustainability from "Assets/icons/sustainability-report.svg"
import { useNavigate } from 'react-router-dom';
import { ReactComponent as DownloadIcon } from "Assets/icons/download.svg";

const CorporateGovernance = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;
    const navigate = useNavigate();

    useEffect(() => {
        if (currentLang !== 'fa') {
            navigate('/');
        }
    }, [currentLang, navigate]);

    const content = {
        fa: {
            download_text: "برای مشاهده و دانلود فایل گزارش حاکمیت شرکتی بورس انرژی ایران ۱۴۰۴، روی دکمه زیر کلیک کنید:"
        },
        en: {
            download_text: "To view and download the Corporate Governance Report of Iran Energy Exchange 2025, click the button below:"
        },
        ar: {
            download_text: "لعرض وتنزيل ملف تقرير حوكمة الشركات لبورصة الطاقة الإيرانية 2025، اضغط على الزر أدناه:"
        }
    };

    const { download_text } = content[currentLang] || content.fa;

    return (
        <div className="megaMenuContent">
            <div className="row h-100">
                <div className="col-4">
                    <img
                        src={Sustainability}
                        className="mx-auto max-width-100 width-100"
                        alt={t('SustainabilityReport')}
                    />
                </div>
                <div className="col-8">
                    <p>
                        {download_text}
                    </p>
                </div>
                <div className="col-12 align-self-end justify-content-end d-flex justify-content-end">
                    <a
                        className="btn btn-download cursor-pointer"
                        href="/Files/corporateGovernance.pdf"
                        download
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        دانلود فایل PDF <span><DownloadIcon /></span>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default CorporateGovernance;